export const chartData = [
  {
    id: 1,
    month: 1,
    hospitalGain: 20000,
    hospitalLost: 8230,
    year: 2022,
  },
  {
    id: 2,
    month: 2,
    hospitalGain: 30000,
    hospitalLost: 17000,
    year: 2022,
  },
  {
    id: 3,
    month: 3,
    hospitalGain: 25000,
    hospitalLost: 4180,
    year: 2022,
  },
  {
    id: 4,
    month: 4,
    hospitalGain: 30000,
    hospitalLost: 25000,
    year: 2022,
  },
  {
    id: 5,
    month: 5,
    hospitalGain: 35000,
    hospitalLost: 24000,
    year: 2022,
  },
  {
    id: 6,
    month: 6,
    hospitalGain: 34000,
    hospitalLost: 8230,
    year: 2022,
  },
  {
    id: 7,
    month: 7,
    hospitalGain: 38000,
    hospitalLost: 9140,
    year: 2022,
  },
  {
    id: 8,
    month: 8,
    hospitalGain: 37000,
    hospitalLost: 10000,
    year: 2022,
  },
  {
    id: 9,
    month: 9,
    hospitalGain: 32000,
    hospitalLost: 7900,
    year: 2022,
  },
  {
    id: 10,
    month: 10,
    hospitalGain: 35000,
    hospitalLost: 17805,
    year: 2022,
  },
  {
    id: 11,
    month: 11,
    hospitalGain: 40000,
    hospitalLost: 18900,
    year: 2022,
  },
  {
    id: 12,
    month: 12,
    hospitalGain: 50000,
    hospitalLost: 8000,
    year: 2022,
  },
];
